import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import DateConstants from './DateConstants';
import moment from 'moment';

var DateTHead = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTHead, _React$Component);

  var _super = _createSuper(DateTHead);

  function DateTHead() {
    _classCallCheck(this, DateTHead);

    return _super.apply(this, arguments);
  }

  _createClass(DateTHead, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var value = props.value;
      var localeData = value.localeData();
      var prefixCls = props.prefixCls;
      var veryShortWeekdays = [];
      var weekDays = [];
      var firstDayOfWeek = localeData.firstDayOfWeek();
      var showWeekNumberEl;
      var now = moment();

      for (var dateColIndex = 0; dateColIndex < DateConstants.DATE_COL_COUNT; dateColIndex++) {
        var index = (firstDayOfWeek + dateColIndex) % DateConstants.DATE_COL_COUNT;
        now.day(index);
        veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
        weekDays[dateColIndex] = localeData.weekdaysShort(now);
      }

      if (props.showWeekNumber) {
        showWeekNumberEl = /*#__PURE__*/React.createElement("th", {
          role: "columnheader",
          className: "".concat(prefixCls, "-column-header ").concat(prefixCls, "-week-number-header")
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-column-header-inner")
        }, "x"));
      }

      var weekDaysEls = weekDays.map(function (day, xindex) {
        return /*#__PURE__*/React.createElement("th", {
          key: xindex,
          role: "columnheader",
          title: day,
          className: "".concat(prefixCls, "-column-header")
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-column-header-inner")
        }, veryShortWeekdays[xindex]));
      });
      return /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
        role: "row"
      }, showWeekNumberEl, weekDaysEls));
    }
  }]);

  return DateTHead;
}(React.Component);

export { DateTHead as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/date/DateTHead.js